module.exports = __webpack_public_path__ + "static/img/apps_logo.197a163.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/apps_logo.svg
// module id = +7BB
// module chunks = 13